import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button } from '@mui/material';

const backgroundImageUrl = '/landing page/666a082ea7eec650bdb030f7d8d0c2a1516b9deb.png';

export const FinalCtaSection: React.FC = () => {
  const { t } = useTranslation(['landing']);
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/auth?signup=true');
  };
  return (
    <Box
      sx={{
        display: 'flex',
        background: 'linear-gradient(to bottom, rgba(0,78,100,0.2), rgba(0,78,100,0.6))',
        borderRadius: '32px',
        overflow: 'hidden',
        width: '100%',
        maxWidth: 1142,
        mx: 'auto',
        my: 8,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
          width: 457,
          minHeight: 300,
          position: 'relative',
          flex: '0 0 40%',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            left: -233,
            top: -118,
            width: 730,
            height: 677,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'scaleY(-1) rotate(180deg)',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              width: 730,
              height: 677,
            }}
          >
            <Box
              component="img"
              src={backgroundImageUrl}
              alt=""
              sx={{
                position: 'absolute',
                inset: 0,
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                inset: 0,
                backgroundColor: 'rgba(217,119,6,0.1)',
              }}
            />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 4,
          p: 8,
          flex: 1,
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
          <Typography
            sx={{
              fontFamily: '"New Order", sans-serif',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '3rem' },
              color: '#004e64',
              lineHeight: 1.25,
            }}
          >
            {t('landing:cta_section.title_line1')}
          </Typography>
          <Typography
            sx={{
              fontFamily: '"New Order", sans-serif',
              fontWeight: 700,
              fontSize: { xs: '2rem', md: '3rem' },
              color: 'rgba(0,78,100,0.6)',
              lineHeight: 1.25,
            }}
          >
            {t('landing:cta_section.title_line2')}
          </Typography>
          <Typography
            sx={{
              fontFamily: '"New Order", sans-serif',
              fontWeight: 600,
              fontSize: { xs: '2rem', md: '3rem' },
              color: '#004e64',
              lineHeight: 1.25,
            }}
          >
            {t('landing:cta_section.title_line3')}
          </Typography>
        </Box>

        <Box sx={{ maxWidth: 576 }}>
          <Typography
            sx={{
              fontFamily: '"New Order", sans-serif',
              fontWeight: 500,
              fontSize: '1.25rem',
              color: 'rgba(0,61,77,0.8)',
              lineHeight: 1.5,
            }}
          >
            {t('landing:cta_section.subtitle')}
          </Typography>
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end', width: '100%', mt: 2 }}>
          <Button
            onClick={handleGetStarted}
            sx={{
              position: 'relative',
              backgroundColor: '#003d4d',
              px: 5,
              py: 2.5,
              borderRadius: '16px',
              boxShadow: '0px 20px 25px -5px rgba(0,61,77,0.2), 0px 8px 10px -6px rgba(0,61,77,0.2)',
              '&:hover': {
                backgroundColor: '#002a38',
              },
            }}
          >
            <Typography
              sx={{
                fontFamily: 'Inter, sans-serif',
                fontWeight: 400,
                fontSize: '1rem',
                color: '#ffffff',
                lineHeight: 1.5,
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}
            >
              {t('landing:cta_section.button')}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Box>
  );
};